/* tslint:disable */
/* eslint-disable */
/**
 * School Reporting Systems API
 * School Reporting Systems.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: tony.henderson@elevenfiftynine.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CountyRequest } from '../model';
// @ts-ignore
import { CountyResponse } from '../model';
// @ts-ignore
import { DistrictRequest } from '../model';
// @ts-ignore
import { DistrictResponse } from '../model';
// @ts-ignore
import { RegionRequest } from '../model';
// @ts-ignore
import { RegionResponse } from '../model';
/**
 * DataLookupApi - axios parameter creator
 * @export
 */
export const DataLookupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {CountyRequest} [countyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCountyGetAllPost: async (apiVersion?: string, countyRequest?: CountyRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/County/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof countyRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(countyRequest !== undefined ? countyRequest : {})
                : (countyRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {DistrictRequest} [districtRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDistrictGetAllPost: async (apiVersion?: string, districtRequest?: DistrictRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/District/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof districtRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(districtRequest !== undefined ? districtRequest : {})
                : (districtRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {RegionRequest} [regionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRegionGetAllPost: async (apiVersion?: string, regionRequest?: RegionRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Region/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (apiVersion !== undefined && apiVersion !== null) {
                localVarHeaderParameter['api-version'] = String(apiVersion);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof regionRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(regionRequest !== undefined ? regionRequest : {})
                : (regionRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataLookupApi - functional programming interface
 * @export
 */
export const DataLookupApiFp = function(configuration?: Configuration) {
    return {
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {CountyRequest} [countyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCountyGetAllPost(apiVersion?: string, countyRequest?: CountyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountyResponse>> {
            const localVarAxiosArgs = await DataLookupApiAxiosParamCreator(configuration).apiCountyGetAllPost(apiVersion, countyRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {DistrictRequest} [districtRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDistrictGetAllPost(apiVersion?: string, districtRequest?: DistrictRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistrictResponse>> {
            const localVarAxiosArgs = await DataLookupApiAxiosParamCreator(configuration).apiDistrictGetAllPost(apiVersion, districtRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {RegionRequest} [regionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRegionGetAllPost(apiVersion?: string, regionRequest?: RegionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegionResponse>> {
            const localVarAxiosArgs = await DataLookupApiAxiosParamCreator(configuration).apiRegionGetAllPost(apiVersion, regionRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DataLookupApi - factory interface
 * @export
 */
export const DataLookupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {CountyRequest} [countyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCountyGetAllPost(apiVersion?: string, countyRequest?: CountyRequest, options?: any): AxiosPromise<CountyResponse> {
            return DataLookupApiFp(configuration).apiCountyGetAllPost(apiVersion, countyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {DistrictRequest} [districtRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDistrictGetAllPost(apiVersion?: string, districtRequest?: DistrictRequest, options?: any): AxiosPromise<DistrictResponse> {
            return DataLookupApiFp(configuration).apiDistrictGetAllPost(apiVersion, districtRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * [BX_GET_ALL]
         * @param {string} [apiVersion] The requested API version
         * @param {RegionRequest} [regionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRegionGetAllPost(apiVersion?: string, regionRequest?: RegionRequest, options?: any): AxiosPromise<RegionResponse> {
            return DataLookupApiFp(configuration).apiRegionGetAllPost(apiVersion, regionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataLookupApi - object-oriented interface
 * @export
 * @class DataLookupApi
 * @extends {BaseAPI}
 */
export class DataLookupApi extends BaseAPI {
    /**
     * [BX_GET_ALL]
     * @param {string} [apiVersion] The requested API version
     * @param {CountyRequest} [countyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataLookupApi
     */
    public apiCountyGetAllPost(apiVersion?: string, countyRequest?: CountyRequest, options?: any) {
        return DataLookupApiFp(this.configuration).apiCountyGetAllPost(apiVersion, countyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_GET_ALL]
     * @param {string} [apiVersion] The requested API version
     * @param {DistrictRequest} [districtRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataLookupApi
     */
    public apiDistrictGetAllPost(apiVersion?: string, districtRequest?: DistrictRequest, options?: any) {
        return DataLookupApiFp(this.configuration).apiDistrictGetAllPost(apiVersion, districtRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * [BX_GET_ALL]
     * @param {string} [apiVersion] The requested API version
     * @param {RegionRequest} [regionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataLookupApi
     */
    public apiRegionGetAllPost(apiVersion?: string, regionRequest?: RegionRequest, options?: any) {
        return DataLookupApiFp(this.configuration).apiRegionGetAllPost(apiVersion, regionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
